import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Table,
  Avatar,
  Typography,
  Drawer,
  Button,
  Space,
  Form,
  Image,
  Upload,
  message,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { getListBanner, createBanner, updateBanner } from "services/banner";
import { upload } from "services/upload";

const { Title, Text } = Typography;

export default function Banner() {
  const [banners, setBanners] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [isEditing, setIsEditing] = useState(true);

  const showDrawer = (banner = null) => {
    setSelectedBanner(banner);
    setVisible(true);
    setIsEditing(banner != null);
  };

  const onClose = () => {
    setSelectedBanner(null);
    form.resetFields();
    setFileList([]);
    setVisible(false);
  };

  const handleSubmit = async (values) => {
    if (isEditing) {
      await updateBanner({ ...values, id: selectedBanner.id });
    } else {
      await createBanner(values);
    }

    message.success("Banner updated successfully!");
    fetchBanners();
    onClose();
  };

  useEffect(() => {
    if (selectedBanner) {
      form.setFieldsValue(selectedBanner);
      setFileList([]);
    }
  }, [selectedBanner, form]);

  const columns = [
    {
      title: "Banner",
      dataIndex: "image_url",
      key: "image_url",
      width: "90%",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
    },
  ];

  const tableData = banners.map((banner, index) => {
    const { image_url, id } = banner;
    return {
      key: index,
      image_url: (
        <Avatar.Group>
          <Image
            width={350}
            src={image_url || "https://via.placeholder.com/40"}
            alt="Banner"
            style={{ borderRadius: 8 }}
          />
          {/* <div className="avatar-info">
            <Title level={5} style={{ marginLeft: 12 }}>
              {image_url}
            </Title>
          </div> */}
        </Avatar.Group>
      ),
      action: (
        <a onClick={() => showDrawer(banner)} key={`a-${id}`}>
          Edit
        </a>
      ),
    };
  });

  const fetchBanners = async () => {
    try {
      const response = await getListBanner();
      if (response?.result) {
        setBanners(response.result || []);
      }
    } catch (err) {
      console.error("Error fetching banners:", err);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleUpload = async (file) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await upload(formData);

      const data = await response.json();
      if (data.status === "success") {
        const fullImageUrl = data.file_path;
        form.setFieldsValue({ image: fullImageUrl });
        setSelectedBanner({
          ...selectedBanner,
          image_url: fullImageUrl,
        });
        message.success("Image uploaded successfully!");
      } else {
        message.error("Upload failed!");
      }
    } catch (err) {
      console.error("Upload error:", err);
      message.error("Failed to upload image!");
    } finally {
      setUploading(false);
    }

    return false; // prevent auto upload
  };

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title="Banner"
              extra={
                <Space size="middle">
                  <Button type="primary" onClick={() => showDrawer()}>
                    Add Banner
                  </Button>
                </Space>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  dataSource={tableData}
                  pagination={false}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      <Drawer
        title={
          <>
            Edit Banner{" "}
            <Text className="subtitle">{selectedBanner?.name || ""}</Text>
          </>
        }
        width={400}
        visible={visible}
        onClose={onClose}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={selectedBanner}
        >
          <Form.Item label="Image" name="image_url">
            {selectedBanner?.image_url ? (
              <div style={{ textAlign: "center" }}>
                <Image
                  width={200}
                  src={selectedBanner.image_url}
                  alt="Banner"
                  style={{ borderRadius: 8 }}
                />
                <div style={{ marginTop: 10 }}>
                  <Button
                    type="link"
                    onClick={() => {
                      form.setFieldsValue({ image_url: "" });
                      setSelectedBanner({
                        ...selectedBanner,
                        image_url: "",
                      });
                    }}
                  >
                    Change Image
                  </Button>
                </div>
              </div>
            ) : (
              <Upload
                listType="picture"
                fileList={fileList}
                beforeUpload={handleUpload}
                onChange={({ fileList }) => setFileList(fileList)}
                showUploadList={false}
                accept="image/*"
              >
                <Button
                  icon={<UploadOutlined />}
                  loading={uploading}
                  disabled={uploading}
                >
                  {uploading ? "Uploading..." : "Upload Image"}
                </Button>
              </Upload>
            )}
          </Form.Item>

          <Form.Item>
            <Space style={{ display: "flex", justifyContent: "end" }}>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="primary" htmlType="submit">
                {isEditing ? "Update" : "Create"}
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
}
